import _ from "lodash";
import React from "react";
import { Col, Media, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import notificationPopUp from "../../NotificationPopUp";

import CommonFunctions from "../../commonFunctions";
import * as consts from "../../constants";

import * as authenticationActions from "../../actions/authenticationActions";
import * as commonActions from "../../actions/commonActions";
import * as networkActions from "../../actions/networkActions";
import * as emissionActions from "../../actions/emissionActions";

import AirBnbDateTimePicker from "../common/airBnbDatepicker/AirBnbDateTimePicker";
import NextPrevButtonToolbar from "../common/NextPrevButtonToolbar";
import PianoFlexSection from "./PianoFlexSection";
import SelectInput from "../common/SelectInput";

import pdfLogo from "../../styles/images/pdfIco_48x48.png";

class QuotationPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      authenticationState: this.props.authenticationState,
      commonState: this.props.commonState,
      emissionState: this.props.emissionState,
      products: [],
      flagDisableFieldByProductCode: false,
      productSelected: null,
    };

    if (
      !authenticationActions.verifyAuthentication(
        this.props.authenticationState,
        this.props.history
      )
    )
      return;
  }

  componentDidCatch(error, info) {
    console.log(error);
    console.log(info);
  }

  componentDidMount() {
    if (this.state.authenticationState.network.id > -1) {
      this.loadProducts(this.state.authenticationState.network.id);
    }
    if (
      !this.state.commonState.configuration ||
      this.state.commonState.configuration.conventions === null ||
      this.state.commonState.configuration.conventions.length === 0
    ) {
      this.props.commonActions
        .loadConfiguration()
        .then(() => {})
        .catch((error) => {
          notificationPopUp.error(
            "Problemi nel caricamento della Configurazione"
          );
        });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return Object.assign({}, prevState, {
      emissionState: nextProps.emissionState,
      commonState: nextProps.commonState,
    });
  }

  addWarranty = () => {
    const emissionState = Object.assign({}, this.state.emissionState);

    var sortArray = _.clone(emissionState.pianoFlex.pianoFlexWarranty).sort(
      function (a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      }
    );

    var newId = -1;
    if (sortArray.length > 0) {
      if (sortArray[0].id < 1) newId = sortArray[0].id - 1;
    }

    if (
      _.isNil(
        this.state.authenticationState.network.pianoFlexIdInsuranceCompany
      )
    ) {
      notificationPopUp.warning(
        "Attenzione: la abilitazione all'utilizzo del Piano Flex non è completa per il tuo profilo del Socio Sostenitore a cui appartiene il tuo utente, chiedi all'amministratore di abilitarlo."
      );
      return;
    }

    emissionState.pianoFlex.pianoFlexWarranty.push({
      amount: 0,
      id: newId,
      idInsuranceCompany:
        this.state.authenticationState.network.pianoFlexIdInsuranceCompany,
      name: "",
      printedNote: "",
    });

    this.props.emissionActions.updateEmission(emissionState);
  };

  deleteWarranty = (warrantyId) => {
    const emissionState = Object.assign({}, this.state.emissionState);
    emissionState.pianoFlex.pianoFlexWarranty =
      emissionState.pianoFlex.pianoFlexWarranty.filter(
        (x) => x.id !== warrantyId
      );
    this.props.emissionActions.updateEmission(emissionState);
  };

  isDayBlocked = (day) => {
    var actualProd = this.state.products.filter(
      (x) => x.id === parseInt(this.state.emissionState.productId, 10)
    )[0];
    if (
      !_.isNil(actualProd) &&
      (actualProd.contractPeriodMode ===
        consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.EXPIRATION_LAST_DAY_OF_YEAR ||
        actualProd.contractPeriodMode ===
          consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE
            .COLLETTIVA_LAST_DAY_OF_YEAR ||
        actualProd.contractPeriodMode ===
          consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.FORFAIT_LAST_DAY_OF_YEAR)
    ) {
      return actualProd.contractStartingDay !== day.date();
    }
    return false;
  };

  nomeContraente = () => {
    // Persona Fisica
    if (
      this.state.emissionState.personType ===
      consts.GENERIC_ENUM.personType[0].value.toString()
    ) {
      return (
        this.state.emissionState.personaFisica.name +
        " " +
        this.state.emissionState.personaFisica.surname
      );
    } else {
      return this.state.emissionState.personaGiuridica.businessName;
    }
  };

  loadProducts = (id) => {
    this.props.networkActions
      .loadActiveNetworkProducts(id)
      .then((products) => {
        // extends products with the Instalment Array and PayMode Array
        for (var i = 0; i < products.length; i++) {
          const appInst = products[i].instalmentMode.split("|");
          products[i].instalmentModeArray =
            consts.GENERIC_ENUM.fractionationType.filter(
              (x) => appInst.indexOf(x.value) > -1
            );

          const appPayMode = products[i].payMode.split("|");
          products[i].payModeArray = consts.GENERIC_ENUM.paymentType.filter(
            (x) => appPayMode.indexOf(x.value) > -1
          );
        }
        this.setState(Object.assign({}, this.state, { products: products }));
      })
      .catch((error) => {
        notificationPopUp.error(error);
      });
  };

  updateContraente = (event) => {
    console.log("");
    const emissionState = Object.assign({}, this.state.emissionState);

    if (event.target.name.startsWith("pianoFlex")) {
      var splits = event.target.name.split(".");
      var propertyName = splits[1];

      if (propertyName === "warranty") {
        var referenceObj = emissionState.pianoFlex.pianoFlexWarranty.filter(
          (x) => x.id === _.toNumber(splits[2])
        )[0];
        referenceObj[splits[3]] = event.target.value;
        if (splits[3] === "name")
          this.productSelected = { name: event.target.value };
      } else {
        emissionState.pianoFlex[propertyName] = event.target.value;
      }

      this.props.emissionActions.updateEmission(emissionState);
    } else {
      if (event.target.name === "productId") {
        emissionState[event.target.name] = event.target.value;
        this.productSelected = this.state.products.filter(
          (x) => x.id === parseInt(event.target.value, 10)
        )[0];
        try {
          var dates = CommonFunctions.expirationContractDates(
            this.state.products.filter(
              (x) => x.id === parseInt(event.target.value, 10)
            )[0],
            null
          );
          emissionState.datiPagamento.startDate = dates.decorrenza;
          emissionState.datiPagamento.endDate = dates.scadenza;
          // Reset Fields
          emissionState.instalmentMode = -1;
          emissionState.payMode = -1;
        } catch (err) {
          console.log("Product not found in product list" + err);
        }
      } else if (event.target.name === "datiPagamento_startDate") {
        try {
          if (_.isNil(event.target.value)) event.target.value = new Date();

          emissionState.datiPagamento.startDate = new Date(event.target.value);

          var actualProd = this.state.products.filter(
            (x) => x.id === parseInt(this.state.emissionState.productId, 10)
          )[0];
          if (!_.isNil(actualProd)) {
            var dates02 = CommonFunctions.expirationContractDates(
              actualProd,
              emissionState.datiPagamento.startDate
            );
            emissionState.datiPagamento.endDate = dates02.scadenza;
          }
        } catch (err) {
          console.log(err);
        }
      } else if (event.target.name === "datiPagamento_endDate") {
        try {
          if (_.isNil(event.target.value)) event.target.value = new Date();
          emissionState.datiPagamento.endDate = new Date(event.target.value);
        } catch (err) {
          console.log(err);
        }
      } else {
        emissionState[event.target.name] = event.target.value;
      }
    }

    this.props.emissionActions.updateEmission(emissionState);
  };

  confermaPreventivo = () => {
    var actualProd = this.state.products.filter(
      (x) => x.id === parseInt(this.state.emissionState.productId, 10)
    )[0];

    if (
      this.state.emissionState.datiPagamento.startDate.getDate() !==
        actualProd.contractStartingDay &&
      actualProd.contractPeriodMode === 0
    ) {
      notificationPopUp.warning(
        "Attenzione: il giorno di partenza deve essere il " +
          actualProd.contractStartingDay +
          "° del Mese per questo Prodotto."
      );
      return;
    }

    // Piano Flex Validation
    if (
      this.state.emissionState.pianoFlex &&
      this.state.emissionState.pianoFlex &&
      actualProd.tariff.isPianoFlex
    ) {
      if (
        _.isNil(this.state.emissionState.pianoFlex.name) ||
        _.isEmpty(this.state.emissionState.pianoFlex.name)
      ) {
        notificationPopUp.warning(
          "Attenzione: il nome del piano è obbligatorio."
        );
        return;
      }

      if (
        _.isNil(this.state.emissionState.pianoFlex.pgFactoryFee) ||
        _.toNumber(this.state.emissionState.pianoFlex.pgFactoryFee) < 0 ||
        _.isNil(this.state.emissionState.pianoFlex.pgEmployeeFee) ||
        _.toNumber(this.state.emissionState.pianoFlex.pgEmployeeFee) < 0 ||
        _.isNil(this.state.emissionState.pianoFlex.pgRelativeFee) ||
        _.toNumber(this.state.emissionState.pianoFlex.pgRelativeFee) < 0 ||
        _.isNil(this.state.emissionState.pianoFlex.pfSubscriberFee) ||
        _.toNumber(this.state.emissionState.pianoFlex.pfSubscriberFee) < 0 ||
        _.isNil(this.state.emissionState.pianoFlex.pfRelative) ||
        _.toNumber(this.state.emissionState.pianoFlex.pfRelative) < 0
      ) {
        notificationPopUp.warning(
          "Attenzione: i valori delle quote non sono corretti."
        );
        return;
      }

      for (
        let index = 0;
        index < this.state.emissionState.pianoFlex.pianoFlexWarranty.length;
        index++
      ) {
        const actualWar =
          this.state.emissionState.pianoFlex.pianoFlexWarranty[index];

        if (_.isNil(actualWar.name) || _.isEmpty(actualWar.name)) {
          notificationPopUp.warning(
            "Attenzione: il nome della Prestazione non è corretto."
          );
          return;
        }

        if (
          _.toNumber(actualWar.amount) <= 0 &&
          actualWar.idInsuranceCompany !==
            consts.GENERIC_ENUM.PIANO_FLEX.COMPANY_FIRST_WARRANTY
        ) {
          notificationPopUp.warning(
            'Attenzione: il valore della Prestazione "' +
              actualWar.name +
              '" non è corretto.'
          );
          return;
        }
      }
    }

    this.props.emissionActions
      .createProposal(this.state.emissionState)
      .then(() => {
        notificationPopUp.info("Preventivo salvato con successo");
      })
      .catch((error) => {
        notificationPopUp.error(error);
      });
  };

  esci = () => {
    this.props.emissionActions.updateEmission(CommonFunctions.createContract());
    this.props.history.push("contracts");
  };

  amountWithFranchigia = (x) => {
    var totalAmountApp =
      x.activeCoverageCap.activeWarrantyAllowance.warrantyWithDiscount +
      (x.activeCoverageCap.activeWarrantyAllowance.warrantyWithDiscount *
        x.activeCoverageCap.taxPercentage) /
        100 +
      (x.activeCoverageCap.activeWarrantyAllowance.warrantyWithDiscount *
        x.activeCoverageCap.forwelfareRights) /
        100 +
      x.activeCoverageCap.rights;
    return (totalAmountApp / (100 - x.activeCoverageCap.sebRights)) * 100;
  };

  render() {
    var productsForSelect = this.state.products.map((value) => {
      return { value: value.id, text: value.name };
    });

    var selectedProduct = undefined;
    if (
      !_.isNil(this.state.emissionState.productId) &&
      this.state.emissionState.productId > -1 &&
      this.state.products &&
      this.state.products.length > 0
    ) {
      selectedProduct = Object.assign(
        {},
        this.state.products.filter(
          (x) => x.id === parseInt(this.state.emissionState.productId, 10)
        )[0]
      );
    }

    // Amonut Calculation Based on selected Product
    var totalAmount = _.isNil(selectedProduct) ? 0 : selectedProduct.costoLordo;

    // Se persona Giuridica devo moltiplicare il valore per il totale dei dipendenti aderenti
    // if (this.state.emissionState.personType === consts.GENERIC_ENUM.personType[1].value && this.state.emissionState.personaGiuridica.employees.length > 0) {
    //     totalAmount = totalAmount * this.state.emissionState.personaGiuridica.employees.length
    //     totalNetAmount = totalNetAmount * this.state.emissionState.personaGiuridica.employees.length
    // }

    var quotaIscrizionePG = 0;
    // Se persona Giuridica quota iscrizione è 100
    if (
      this.state.emissionState.personType ===
      consts.GENERIC_ENUM.personType[1].value
    ) {
      quotaIscrizionePG = 100;
    }

    // To Be Added Quota Iscrizione this is 0 for PG
    const quotaIscrizioneAndQuota =
      CommonFunctions.getValuesForQuotaIscrizioneAndQuota(
        this.state.emissionState,
        this.state.commonState,
        selectedProduct
      );

    let startDate = null;
    if (
      this.state.emissionState.datiPagamento.startDate &&
      CommonFunctions.isValidDate(
        this.state.emissionState.datiPagamento.startDate
      )
    )
      startDate =
        this.state.emissionState.datiPagamento.startDate.toISOString();
    else startDate = this.state.emissionState.datiPagamento.startDate;

    let endDate = null;
    if (
      this.state.emissionState.datiPagamento.endDate &&
      CommonFunctions.isValidDate(
        this.state.emissionState.datiPagamento.endDate
      )
    )
      endDate = this.state.emissionState.datiPagamento.endDate.toISOString();
    else endDate = this.state.emissionState.datiPagamento.endDate;
    return (
      <div className="container">
        <h1>Inserisci Nuova Adesione</h1>
        <Row>
          <Col md={12}>
            <Row>
              <div className="panel panel-default x-panel">
                <div className="panel-heading">
                  <span
                    className="glyphicon glyphicon-book"
                    aria-hidden="true"
                  ></span>{" "}
                  Scelta Piano Mutualistico
                </div>
                <div className="panel-body">
                  <SelectInput
                    name="productId"
                    id="productId"
                    label="Piano Mutualistico"
                    defaultOptionText=""
                    defaultOptionValue={-1}
                    disabled={
                      this.state.emissionState.status !==
                      consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE
                    }
                    value={this.state.emissionState.productId}
                    options={productsForSelect}
                    onChange={this.updateContraente}
                  />

                  {_.isUndefined(selectedProduct) ? (
                    ""
                  ) : (
                    <SelectInput
                      name="instalmentMode"
                      label="Frazionamento"
                      defaultOptionText=""
                      defaultOptionValue={-1}
                      disabled={
                        this.state.emissionState.status !==
                        consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE
                      }
                      value={this.state.emissionState.instalmentMode}
                      options={selectedProduct.instalmentModeArray}
                      onChange={this.updateContraente}
                    />
                  )}

                  {_.isUndefined(selectedProduct) ? (
                    ""
                  ) : (
                    <SelectInput
                      name="payMode"
                      label="Metodo di pagamento"
                      defaultOptionText=""
                      defaultOptionValue={-1}
                      disabled={
                        this.state.emissionState.status !==
                        consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE
                      }
                      value={this.state.emissionState.payMode}
                      options={selectedProduct.payModeArray}
                      onChange={this.updateContraente}
                    />
                  )}
                </div>
              </div>
            </Row>
            <Row>
              <div
                className="panel panel-default x-panel"
                style={{ border: "none" }}
              >
                <div className="panel-heading">Riepilogo</div>
                <div className="panel-body">
                  <Row>
                    <Col xs={12} className="quotationTd">
                      Contraente: {this.nomeContraente()}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6} className="quotationTd quotionCaledar">
                      <AirBnbDateTimePicker
                        disabled={
                          this.state.emissionState.productId < 0 ||
                          this.state.emissionState.status !==
                            consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE
                        }
                        isDayBlocked={this.isDayBlocked}
                        label="Decorrenza"
                        name="datiPagamento_startDate"
                        onChange={this.updateContraente}
                        required={true}
                        value={startDate}
                      />
                    </Col>
                    <Col xs={6} className="quotationTd quotionCaledar">
                      {selectedProduct &&
                      selectedProduct.contractPeriodMode ===
                        consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.COVID_19 &&
                      _.toInteger(this.state.emissionState.personType) ===
                        consts.GENERIC_ENUM.personType[1].value ? (
                        <AirBnbDateTimePicker
                          disabled={
                            this.state.emissionState.productId < 0 ||
                            this.state.emissionState.status !==
                              consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE
                          }
                          isDayBlocked={this.isDayBlocked}
                          label="Scadenza"
                          name="datiPagamento_endDate"
                          onChange={this.updateContraente}
                          required={true}
                          value={endDate}
                        />
                      ) : (
                        <p
                          style={{
                            position: "absolute",
                            fontSize: 15,
                            top: 15,
                          }}
                        >
                          {" "}
                          Scadenza:{" "}
                          {CommonFunctions.dateToString(
                            this.state.emissionState.datiPagamento.endDate
                          )}
                        </p>
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </Row>
            {!_.isNil(selectedProduct) && selectedProduct.tariff.isPianoFlex ? (
              <Row>
                <PianoFlexSection
                  addWarranty={this.addWarranty}
                  commonState={this.state.commonState}
                  contract={this.state.emissionState}
                  deleteWarranty={this.deleteWarranty}
                  onChange={this.updateContraente}
                  productSelected={this.productSelected}
                />
              </Row>
            ) : (
              ""
            )}

            {_.isUndefined(selectedProduct) ||
            selectedProduct.tariff.isPianoFlex ? (
              ""
            ) : (
              <Row>
                <div className="panel panel-default x-panel">
                  <div className="panel-heading">
                    <span
                      className="glyphicon glyphicon-list"
                      aria-hidden="true"
                    ></span>{" "}
                    Prestazioni
                  </div>
                  <div className="panel-body">
                    {authenticationActions.canISeeWarrantiesQuotations(
                      this.state.authenticationState
                    ) ? (
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>Garanzia</th>
                            <th className="text-right">Copertura</th>
                            <th className="text-right">Franchigia</th>
                            <th className="text-right">Costo Netto Annuale</th>
                            <th className="text-right">Costo Lordo Annuale</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedProduct.tariff.warranties.map((warranty) =>
                            warranty.activeCoverageCap != null ? (
                              <tr key={warranty.id}>
                                <td>{warranty.warrantyName}</td>
                                <td className="text-right">
                                  {CommonFunctions.numberToItalianEuroFormat(
                                    warranty.activeCoverageCap.coverageCap
                                  )}
                                </td>
                                <td className="text-right">
                                  {CommonFunctions.numberToItalianEuroFormat(
                                    warranty.activeCoverageCap
                                      .activeWarrantyAllowance != null
                                      ? warranty.activeCoverageCap
                                          .activeWarrantyAllowance.allowance
                                      : 0
                                  )}
                                </td>
                                <td className="text-right">
                                  {CommonFunctions.numberToItalianEuroFormat(
                                    warranty.activeCoverageCap
                                      .activeWarrantyAllowance != null
                                      ? warranty.activeCoverageCap
                                          .activeWarrantyAllowance
                                          .warrantyWithDiscount
                                      : warranty.activeCoverageCap
                                          .annualNetValue
                                  )}
                                </td>
                                <td className="text-right">
                                  {CommonFunctions.numberToItalianEuroFormat(
                                    warranty.activeCoverageCap
                                      .activeWarrantyAllowance != null
                                      ? this.amountWithFranchigia(warranty)
                                      : warranty.activeCoverageCap.annualValue
                                  )}
                                </td>
                              </tr>
                            ) : (
                              ""
                            )
                          )}
                        </tbody>
                      </table>
                    ) : (
                      ""
                    )}
                    <div className="well text-left">
                      {/* {quotaIscrizioneAndQuota.subscriptions.map((val) => <Row key={val.type}><label>{val.label}:{CommonFunctions.numberToItalianEuroFormat(val.cost)}</label></Row>)} */}
                      <Row>
                        <b>
                          Totale contributo annuale:{" "}
                          <span style={{ fontSize: 20 }}>
                            {CommonFunctions.numberToItalianEuroFormat(
                              totalAmount
                            )}
                          </span>
                        </b>
                      </Row>
                      {!_.isNil(this.state.emissionState.personaFisica.name) &&
                      !_.isEmpty(
                        this.state.emissionState.personaFisica.name
                      ) ? (
                        <Row>(l'importo comprende la quota associativa)</Row>
                      ) : (
                        <Row>
                          (importo per singola adesione al netto della quota
                          associativa)
                        </Row>
                      )}
                    </div>
                  </div>
                </div>
              </Row>
            )}

            {_.isArray(this.state.emissionState.documents) &&
            this.state.emissionState.documents.length > 0 ? (
              <Row>
                <div className="panel panel-default x-panel">
                  <div className="panel-heading">
                    <span
                      className="glyphicon glyphicon-book"
                      aria-hidden="true"
                    ></span>{" "}
                    Documenti
                  </div>
                  <div className="panel-body">
                    {this.state.emissionState.documents.map((doc) => {
                      return (
                        <Media key={doc.id}>
                          <Media.Left>
                            <img
                              width={48}
                              height={48}
                              src={pdfLogo}
                              alt="pdf"
                            />
                          </Media.Left>
                          <Media.Body>
                            <Media.Heading>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={
                                  process.env.REACT_APP_DOCUMENT_URL +
                                  doc.id +
                                  "?token=" +
                                  encodeURI(
                                    this.state.authenticationState.token
                                  )
                                }
                              >
                                {" "}
                                {doc.fileName}{" "}
                              </a>
                            </Media.Heading>
                          </Media.Body>
                        </Media>
                      );
                    })}
                  </div>
                </div>{" "}
              </Row>
            ) : (
              ""
            )}
            <Row>
              {this.state.emissionState.status ===
              consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE ? (
                <NextPrevButtonToolbar
                  nextText="Conferma Preventivo"
                  onClickNext={this.confermaPreventivo}
                  backtext="Indietro"
                  activeBackButton={true}
                  activeNextButton={
                    !_.isUndefined(selectedProduct) &&
                    _.toNumber(this.state.emissionState.instalmentMode) > 0 &&
                    _.toNumber(this.state.emissionState.payMode) > 0
                  }
                  onClickBack={() => {
                    this.props.history.push("emission");
                  }}
                />
              ) : (
                ""
              )}
              {this.state.emissionState.status ===
              consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO ? (
                <NextPrevButtonToolbar
                  nextText="Esci"
                  onClickNext={this.esci}
                  backtext="Indietro"
                  activeBackButton={false}
                  activeNextButton={true}
                  onClickBack={this.esci}
                />
              ) : (
                ""
              )}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    authenticationState: state.authenticationState,
    commonState: state.commonState,
    emissionState: state.emissionState,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    commonActions: bindActionCreators(commonActions, dispatch),
    authenticationActions: bindActionCreators(authenticationActions, dispatch),
    networkActions: bindActionCreators(networkActions, dispatch),
    emissionActions: bindActionCreators(emissionActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationPage);
